import {isNil} from 'ramda';

import {workshopRoutes} from '@dms/routes';

import {composePath, Nullish} from 'shared/web';

import {workshopSearchParams} from '../constants/workshopSearchParams';
import {queryParams} from './queryParams';

type OpenVehicleHistoryServiceRequestParams = {
  serviceCaseId: string | Nullish;
  serviceOrderId: string | Nullish;
  serviceJobId: string;
};

export function openVehicleHistoryServiceRequest(params: OpenVehicleHistoryServiceRequestParams) {
  // Without the id, composePath resolves to the service case LIST route — opening a tab there is
  // worse than doing nothing.
  if (isNil(params.serviceCaseId)) {
    return;
  }

  const path = composePath(workshopRoutes.serviceCaseDetail, {
    // react-router v7 generatePath percent-encodes named (:param) values — pre-encoding here would
    // double-encode. Splat ('*') params are still interpolated raw, this guarantee is named-only.
    params: {id: params.serviceCaseId},
    queryParams: {
      [queryParams.COMPONENT_SECTIONS_SECTION]: workshopSearchParams.serviceDetail.orders,
      [queryParams.SERVICE_CASE_ORDER_ID]: params.serviceOrderId ?? '',
      [queryParams.SERVICE_CASE_OPEN_JOB_ID]: params.serviceJobId,
    },
  });

  window.open(path);
}
